import React from 'react'
import {Grid, FormControl, InputLabel, TextField, FormHelperText} from '@material-ui/core'
export default function WTextField({data, onChange, tabActive}) {
  return (
    <FormControl fullWidth variant="outlined" className="ap-textfield" style={{width: 320}}>
      <TextField
        id="outlined-adornment-amount"
        value={'Calculation value viewable in action history'}
        disabled
        type={'text'}
        labelWidth={60}
        label={data.name}
        variant="outlined"
        InputLabelProps={{
          shrink: true,
        }}
      />
      <FormHelperText>
        {(() => {
          if (
            (tabActive === 'upcoming' && data.is_required) ||
            (tabActive === 'ongoing' && data.is_required_return)
          ) {
            return 'required*'
          } else {
            return 'optional'
          }
        })()}
      </FormHelperText>
    </FormControl>
  )
}
